import { type CSSProperties, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const visuallyHiddenStyle: CSSProperties = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0,
};

export default function RouteAnnouncer() {
  const { t } = useTranslation();
  const location = useLocation();
  const statusRef = useRef<HTMLParagraphElement | null>(null);

  useEffect(() => {
    if (!statusRef.current) {
      return;
    }

    const routeLabel = document.title || t("common.status.navigatedTo", { path: location.pathname });
    statusRef.current.textContent = routeLabel;
  }, [location.pathname, t]);

  return (
    <p ref={statusRef} role="status" aria-live="polite" aria-atomic="true" style={visuallyHiddenStyle} />
  );
}